import * as React from 'react';
import { useEffect, useState } from 'react';
import { Menu } from '@headlessui/react';

import { classNames, getWindowSize, addSlash } from '../utils';

const SubMenu = ({ pages, currentPath, submenuLabelMenu, submenuLabelMore }) => {
  const [windowSize, setWindowSize] = useState(getWindowSize().innerWidth);
  const [visibleElements, setVisibleElements] = useState(pages.length);
  const [notVisibleElements, setOverflowingElements] = useState(0);

  const getOverflowingElements = (ul) => {
    let visibleElements = 0;
    let notVisibleElements = 0;
    // if ul Width <= 768px add 2 elements to notVisibleElements
    if (ul.clientWidth <= 1024) {
      visibleElements = pages.length - 2;
      notVisibleElements = 2;
    } else {
      visibleElements = pages.length;
      notVisibleElements = 0;
    }

    return {
      notOverflowingElements: visibleElements,
      overflowingElements: notVisibleElements,
    };
  };

  const handleWindowResize = () => {
    // if window expands, add elements to visibleElements
    let { innerWidth } = window;
    // setWindowSize({ innerWidth, innerHeight });
    if (Math.abs(windowSize - innerWidth) < 50) {
      return;
    }

    let { notOverflowingElements, overflowingElements } = getOverflowingElements(
      document.querySelector('.sub-nav-wrapper > .nav-inner > nav > ul'),
      windowSize < innerWidth
    );
    setWindowSize(innerWidth);
    setVisibleElements(notOverflowingElements);
    setOverflowingElements(overflowingElements);
  };
  useEffect(() => {
    const { notOverflowingElements, overflowingElements } = getOverflowingElements(
      document.querySelector('.sub-nav-wrapper > .nav-inner > nav > ul')
    );
    if (notOverflowingElements !== visibleElements) {
      setVisibleElements(notOverflowingElements);
      setOverflowingElements(overflowingElements);
    }
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });

  const setMenuLabel = () => {
    return windowSize < 768 ? submenuLabelMenu : submenuLabelMore;
  };
  return (
    <div className="sub-nav-wrapper hidden sm:block col-span-12">
      <div className="nav-inner">
        <nav>
          <ul>
            {pages.map((page, index) => {
              if (index < visibleElements) {
                return (
                  <li key={page.text}>
                    <a
                      href={addSlash(page.url)}
                      title={page.text}
                      className={currentPath.startsWith(page.url) ? 'current' : ''}
                    >
                      {page.text}
                    </a>
                  </li>
                );
              }
            })}
            {notVisibleElements > 0 && (
              <Menu as="li" className="mobile-menu">
                {({ open }) => (
                  <>
                    <Menu.Button>
                      <div className={classNames('mobile-menu-button', open && 'open')}>
                        {setMenuLabel()}
                      </div>
                    </Menu.Button>
                    <Menu.Items className="mobile-menu-items">
                      {pages.slice(visibleElements).map((item) => {
                        return (
                          <Menu.Item>
                            {({ active }) => (
                              <a className={`${active && 'font-bold'}`} href={addSlash(item.url)}>
                                {item.text}
                              </a>
                            )}
                          </Menu.Item>
                        );
                      })}
                    </Menu.Items>
                  </>
                )}
              </Menu>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};
export default SubMenu;
